import { TreeSelect, TreeSelectProps } from "antd";
import usePastasTree from "core/features/documentos/hooks/usePastasTree";
import { DocumentoPastaTreeItem } from "core/features/documentos/typings";
import { DataNode } from "antd/lib/tree";
import { useMemo } from "react";

interface SelectDocumentoPaiProps<T> extends TreeSelectProps<T> {
  errorMessage?: string;
  isInvalid?: boolean;
}

function getNodes(data: DocumentoPastaTreeItem[] | undefined): DataNode[] {
  if (!data) {
    return [];
  }

  return data?.map((item) => ({
    key: item.id,
    children: getNodes(item.children ?? []),
    isLeaf: !item.children?.length,
    title: item.nome,
    disableCheckbox: true,
  }));
}

function SelectDocumentoPai<T>({
  isInvalid,
  errorMessage,
  ...rest
}: SelectDocumentoPaiProps<T>) {
  const { data: pastasTree, isLoading, isFetching } = usePastasTree();

  const nodes = useMemo(() => getNodes(pastasTree), [pastasTree]);

  return (
    <TreeSelect
      {...rest}
      showSearch
      style={{
        width: "100%",
        borderColor: errorMessage ? "red" : "transparent",
        borderWidth: errorMessage ? "1px" : "0px",
        borderStyle: "solid",
      }}
      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
      placeholder="Selecione a pasta..."
      allowClear
      treeDefaultExpandAll
      loading={isLoading || isFetching}
      treeData={nodes}
    />
  );
}

export default SelectDocumentoPai;
